import { getCSRFToken, fetchCSRFToken } from "./csrf";

const BASE_URL = "/api/v1";

async function request(method, endpoint, data = null) {
  let csrfToken = getCSRFToken();

  if (!csrfToken) {
    await fetchCSRFToken();
    csrfToken = getCSRFToken();
  }

  const headers = {
    "Content-Type": "application/json",
    "X-CSRFToken": csrfToken,
  };

  const options = {
    method,
    headers,
    credentials: "include",
  };

  if (data) options.body = JSON.stringify(data);

  const response = await fetch(`${BASE_URL}${endpoint}`, options);

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || errorData.detail || `${response.status}: ${response.statusText}`);
  }

  // Handle DELETE requests that might not return JSON
  if (method === 'DELETE' && response.status === 204) {
    return {}; // Return empty object for successful DELETE with no content
  }

  return response.json();
}

export async function addVideoFavorite(videoLessonId) {
  const payload = { lesson: parseInt(videoLessonId) };
  return request("POST", `/favorites/video-lessons/`, payload);
}

export async function removeVideoFavorite(favoriteId) {
  return request("DELETE", `/favorites/video-lessons/${favoriteId}/`);
}

export async function getFavoriteStatus(videoLessonId) {
  try {
    const response = await request("GET", `/favorites/video-lessons/`);
    const favorite = response.results?.find(fav => fav.lesson === parseInt(videoLessonId));

    if (favorite) {
      return { isFavorited: true, favoriteId: favorite.id };
    } else {
      return { isFavorited: false, favoriteId: null };
    }
  } catch (error) {
    console.error('Error checking favorite status:', error);
    return { isFavorited: false, favoriteId: null };
  }
}

export async function toggleVideoFavorite(videoLessonId, currentFavoriteId = null, isFavorited = false) {
  if (isFavorited) {
    // Remove from favorites
    if (currentFavoriteId) {
      // We have the favorite ID, use it directly
      return removeVideoFavorite(currentFavoriteId);
    } else {
      // We don't have the favorite ID, fetch it from API first
      console.log('Missing favorite ID, fetching from API...');
      const { favoriteId } = await getFavoriteStatus(videoLessonId);
      if (favoriteId) {
        return removeVideoFavorite(favoriteId);
      } else {
        throw new Error('Could not find favorite record to remove');
      }
    }
  } else {
    // Add to favorites
    return addVideoFavorite(videoLessonId);
  }
}